import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { hasSettingsChips } from '../../settings-predicates';
import { AgreementNameChip } from '../AgreementNameChip/AgreementNameChip';
import { ClientNameChip } from '../ClientNameChip/ClientNameChip';
import { ContactNameChip } from '../ContactNameChip/ContactNameChip';
import { EffectiveDateChip } from '../EffectiveDateChip/EffectiveDateChip';
import { EffectiveDateModeChip } from '../EffectiveDateModeChip/EffectiveDateModeChip';
import { LastUpdatedChip } from '../LastUpdatedChip/LastUpdatedChip';
import { ModifiedByChip } from '../ModifiedByChip/ModifiedByChip';
import { NetDaysChip } from '../NetDaysChip/NetDaysChip';
import { presentQuantifiers } from '../ServicesChips/service-predicate';
import { ServicesChips } from '../ServicesChips/ServicesChips';
import { SettingsChips } from '../SettingsChips/SettingsChips';
import { StatusChip } from '../StatusChip/StatusChip';
import { UnknownPredicateChip } from '../UnknownPredicateChip/UnknownPredicateChip';
export const buildPredicateChipUnits = (param)=>{
    let { predicate, testIds, callbacks } = param;
    var _predicate_paymentSettings;
    const showServices = predicate.services != null && presentQuantifiers(predicate.services).length > 0;
    const units = [];
    if (predicate.agreementName != null) {
        units.push({
            key: 'agreementName',
            node: /*#__PURE__*/ _jsx(AgreementNameChip, {
                testId: testIds.AgreementName,
                predicate: predicate.agreementName,
                onChange: callbacks.onAgreementNameChange
            })
        });
    }
    if (predicate.clientName != null) {
        units.push({
            key: 'clientName',
            node: /*#__PURE__*/ _jsx(ClientNameChip, {
                testId: testIds.ClientName,
                predicate: predicate.clientName,
                onChange: callbacks.onClientNameChange
            })
        });
    }
    if (predicate.contactName != null) {
        units.push({
            key: 'contactName',
            node: /*#__PURE__*/ _jsx(ContactNameChip, {
                testId: testIds.ContactName,
                predicate: predicate.contactName,
                onChange: callbacks.onContactNameChange
            })
        });
    }
    if (predicate.status != null) {
        units.push({
            key: 'status',
            node: /*#__PURE__*/ _jsx(StatusChip, {
                testId: testIds.Status,
                predicate: predicate.status,
                onChange: callbacks.onStatusChange
            })
        });
    }
    if (predicate.effectiveDate != null) {
        units.push({
            key: 'effectiveDate',
            node: /*#__PURE__*/ _jsx(EffectiveDateChip, {
                testId: testIds.EffectiveDate,
                predicate: predicate.effectiveDate,
                onChange: callbacks.onEffectiveDateChange
            })
        });
    }
    if (predicate.effectiveDateMode != null) {
        units.push({
            key: 'effectiveDateMode',
            node: /*#__PURE__*/ _jsx(EffectiveDateModeChip, {
                testId: testIds.EffectiveDateMode,
                predicate: predicate.effectiveDateMode,
                onChange: callbacks.onEffectiveDateModeChange
            })
        });
    }
    if (predicate.lastUpdatedAt != null) {
        units.push({
            key: 'lastUpdatedAt',
            node: /*#__PURE__*/ _jsx(LastUpdatedChip, {
                testId: testIds.LastUpdated,
                predicate: predicate.lastUpdatedAt,
                onChange: callbacks.onLastUpdatedAtChange
            })
        });
    }
    if (predicate.lastModifiedBy != null) {
        units.push({
            key: 'lastModifiedBy',
            node: /*#__PURE__*/ _jsx(ModifiedByChip, {
                testId: testIds.ModifiedBy,
                predicate: predicate.lastModifiedBy,
                onChange: callbacks.onLastModifiedByChange
            })
        });
    }
    if (((_predicate_paymentSettings = predicate.paymentSettings) === null || _predicate_paymentSettings === void 0 ? void 0 : _predicate_paymentSettings.netTerms) != null) {
        units.push({
            key: 'netTerms',
            node: /*#__PURE__*/ _jsx(NetDaysChip, {
                testId: testIds.NetDays,
                predicate: predicate.paymentSettings.netTerms,
                onChange: callbacks.onNetTermsChange
            })
        });
    }
    if (hasSettingsChips(predicate.paymentSettings, predicate.agreementSettings)) {
        units.push({
            key: 'settings',
            node: /*#__PURE__*/ _jsx(SettingsChips, {
                testId: testIds.Settings,
                paymentSettings: predicate.paymentSettings,
                agreementSettings: predicate.agreementSettings,
                onPaymentSettingsChange: callbacks.onPaymentSettingsChange,
                onAgreementSettingsChange: callbacks.onAgreementSettingsChange
            })
        });
    }
    if (showServices && predicate.services != null) {
        units.push({
            key: 'services',
            node: /*#__PURE__*/ _jsx(ServicesChips, {
                testId: testIds.Services,
                services: predicate.services,
                onChange: callbacks.onServicesChange
            })
        });
    }
    return units;
};
export const buildUnknownChipUnits = (param)=>{
    let { keys, testIds, onRemove } = param;
    return keys.map((key)=>({
            key: "unknown-".concat(key),
            node: /*#__PURE__*/ _jsx(UnknownPredicateChip, {
                testId: testIds.Unknown(key),
                fieldName: key,
                onRemove: ()=>onRemove(key)
            })
        }));
};
